import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

let currentToken = null;

const checkJwtExpiration = async (jwt, refreshToken) => {
  const decodedToken = jwtDecode(jwt);
  const expirationDate = new Date(decodedToken.exp * 1000);

  const currentTime = new Date();
  const timeDifference = expirationDate.getTime() - currentTime.getTime();
  const timeDifferenceInMinutes = timeDifference / (1000 * 60);

  if (timeDifferenceInMinutes <= 5 && refreshToken) {
    try {
      const res = await axios.post(
        `${process.env.BFFV2_BASE_URL}/auth/refresh`,
        { refreshToken },
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        },
      );

      if (res.status !== 201) {
        window.postMessage({ name: 'iConnectionsEventBus', type: 'logout' }, '*');
      }

      if (res.data.token) {
        window.postMessage(
          {
            name: 'iConnectionsEventBus',
            type: 'refreshTokens',
            token: res.data.token,
            refreshToken: res.data.refreshToken,
          },
          '*',
        );
        return res.data.token;
      }
      window.postMessage({ name: 'iConnectionsEventBus', type: 'logout' }, '*');
    } catch (error) {
      window.postMessage({ name: 'iConnectionsEventBus', type: 'logout' }, '*');
    }
  }
  return false;
};

export const http = axios.create({
  baseURL: process.env.BFF_BASE_URL,
});

http.interceptors.request.use(async (config) => {
  const authorizationHeader = config.headers.Authorization;
  const refreshToken = config.headers['X-Refresh-Token'];

  if (!refreshToken) {
    return config;
  }

  if (authorizationHeader && authorizationHeader.startsWith('Bearer ')) {
    const jwt = authorizationHeader.substring(7);
    const newJwt = await checkJwtExpiration(jwt, refreshToken);
    if (newJwt) {
      config.headers.Authorization = `Bearer ${newJwt}`;
    }
  }

  delete config.headers['X-Refresh-Token'];

  return config;
});

export const setAuthorizationHeader = (jwt, refreshToken) => {
  currentToken = jwt;
  http.defaults.headers.common.Authorization = `Bearer ${jwt}`;
  http.defaults.headers.common['X-Refresh-Token'] = refreshToken;
};

export const getToken = () => currentToken;

export default http;
